/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { PencilIcon } from "@heroicons/react/solid";
import { useDispatch, useSelector } from "react-redux";

import ReactTable from "components/lib/Global/ReactTable";
import { Constants } from "config/constants";
import SearchInput from "components/lib/Shared/SearchInput";
import { getCompanyNameWithSuffix } from "utils/company";
import { getMaintainYourCompanyReviewStatus } from "config/documentData";
import EmptyTableState from "components/lib/Shared/EmptyTableState";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { useDebounce } from "use-debounce";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { getCompaniesTransactionsReviewAsync } from "state/slices/companiesTransactions";

const ReviewApplicationList = ({ setSelectedCompany = () => null }) => {
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const defaultRowsPerPage = 7;
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounce(searchTerm, 1000);
  const [rowsPerPage] = useState(10);
  const currentUser = useSelector((state) => state.userSlice);
  const { companiesTransactionsReview, getCompaniesTransactionsReview } =
    useSelector((state) => state.companiesTransactionsSlice);
  const history = useHistory();

  useEffect(() => {
    dispatch(
      getCompaniesTransactionsReviewAsync({
        queryParams: {
          limit: rowsPerPage,
          skip: (currentPage - 1) * rowsPerPage,
          search: debouncedSearchTerm,
          order: "desc",
        },
      })
    );
  }, [currentPage, debouncedSearchTerm, defaultRowsPerPage]);

  function handleSearch(event) {
    setSearchTerm(event.target.value);
  }

  const columns = [
    {
      Header: "Batch No.",
      accessor: "BatchNo",
      Cell: ({ row }) => row.original?.batchNo || "-",
    },
    {
      Header: "Name.",
      accessor: "companyName1",
      Cell: ({ row }) => {
        if (row.original?.companyInfo) {
          return getCompanyNameWithSuffix(row.original.companyInfo);
        } else {
          return getCompanyNameWithSuffix(row.original);
        }
      },
    },
    {
      Header: "Application Type",
      accessor: "applicationType",

      Cell: ({ row }) => {
        if (row.original?.applicationType) {
          return row.original?.applicationType;
        } else {
          if (row?.original?.transferYourBusinessInitiator) {
            return "Transfer Your Business";
          }
          return "Incorporation";
        }
      },
    },
    {
      Header: "Change Type",
      accessor: "changeType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        return (
          capitalize(original?.changeType) || original?.companyInfo?.type || "-"
        );
      },
    },
    {
      Header: "Transaction Type",
      accessor: "transactionType",
      Cell: ({ row: { original } }) => {
        const capitalize = (str) => {
          if (!str) return null;
          let transactionType =
            str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
          return transactionType;
        };

        if (original?.transferYourBusinessInitiator) {
          return "Transfer Your Business";
        }

        return capitalize(original?.transactionType) || "Automatic";
      },
    },
    {
      Header: "Tnx No.",
      accessor: "TnxNo",
      Cell: ({ row: { original } }) => {
        return (
          original?.trxRef || original?.companyInfo?.registrationNumber || "-"
        );
      },
    },
    {
      Header: "Date",
      Cell: ({ row: { original } }) => {
        const date = original?.createdAt;
        return date ? format(new Date(date), "yyyy/MM/dd") : "N/A";
      },
    },
    {
      Header: "Status",
      Cell: ({ row }) => {
        if (row.original?.applicationType) {
          return getMaintainYourCompanyReviewStatus(row.original?.status);
        } else {
          return row.original?.status || row.original?.status;
        }
      },
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        const handleReviewBtnClick = () => {
          if (!row?.original?.trxRef) {
            setSelectedCompany({
              ...row.original,
              role: Constants.ROLES.REVIEWER,
            });
          } else if (row?.original?.trxRef) {
            history.push(
              `/companies/${row.original.companyInfo._id}/dashboard/transactions/${row.original._id}/review`
            );
          }
        };
        return (
          <button onClick={handleReviewBtnClick}>
            <span>Review</span>
            <PencilIcon className="inline w-4 h-4" />
          </button>
        );
      },
    },
  ];

  function handleSearch(event) {
    setSearchTerm(event.target.value);
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between my-2">
        <div className="flex items-center space-x-4">
          <h2 className="font-semibold">Filter by:</h2>
        </div>
        <SearchInput value={searchTerm} handleOnChange={handleSearch} />
      </div>
      {companiesTransactionsReview.items.length > 0 ? (
        <div className="w-full bg-white shadow">
          <div className="w-full">
            <ReactTable
              columns={columns}
              data={companiesTransactionsReview.items}
              currentPage={currentPage}
              totalRows={companiesTransactionsReview.totalCount}
              setCurrentPage={setCurrentPage}
              paginate
              isLoading={getCompaniesTransactionsReview.status === "loading"}
            />
          </div>
        </div>
      ) : (
        <>
          {getCompaniesTransactionsReview.status === "loading" ? (
            <div className="z-10 flex items-center justify-center mt-10">
              <SpinnerIcon className="text-gray-400" />
            </div>
          ) : (
            <EmptyTableState>No companies</EmptyTableState>
          )}
        </>
      )}
    </div>
  );
};

export default ReviewApplicationList;
